/**
 * Copyright (c) 2020-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

import React, { Component, type ReactNode, Children } from 'react'
import PropTypes from 'prop-types'
import { interceptor, type Config } from './FetchInterceptor'
import omit from 'lodash.omit'

export type AuthenticationProviderProps = Config & {
  children: ReactNode
}

/**
 * Componente responsável por interceptar as requisições http e adicionar os
 * cabeçalhos exigidos pela Microsoft e Sensedia de forma transparente a aplicação
 *
 * @example
 * <AuthenticationProvider
 *   baseURL='http://localhost:3001'
 *   ignoredUrls={[
 *     { method: 'POST', path: '/example/ignore' }
 *   ]}>
 *   <App />
 * </AuthenticationProvider>
 */
export class AuthenticationProvider extends Component<AuthenticationProviderProps> {
  static propTypes = {
    baseURL: PropTypes.string.isRequired,
    ignoredURL: PropTypes.arrayOf(PropTypes.shape({
      method: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      aditionalHeadersIgnoredUrl: PropTypes.string
    })).isRequired,
    url401: PropTypes.string.isRequired,
    url403: PropTypes.string,
    use403Redirect: PropTypes.bool,
    children: PropTypes.element.isRequired
  }

  componentWillMount () {
    interceptor(omit(this.props, ['children']))
  }

  render () {
    return Children.only(this.props.children)
  }
}
